import React, {Fragment} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert, DropdownItem} from 'reactstrap';
import {SellAPI} from "api";

class DeleteSell extends React.Component {
    constructor(props) {
        super(props);
    }

    showModal() {
        const self = this;
        global.SweetAlert.fire({
            title: "Elimina vendita",
            text: 'Attenzione, eliminando la vendita annullerai tutti i pagamenti ad esso associato. Vuoi procedere?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, elimina',
            cancelButtonText: 'Annulla',
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ms-1'
            },
            buttonsStyling: false,
            showLoaderOnConfirm: true,
            preConfirm: function() {
                return new Promise(function(resolve, reject) {
                    SellAPI.remove(self.props.id).then(() => {
                        resolve();
                    }).catch(() => {
                        global.SweetAlert.fire({
                            icon: 'error',
                            title: 'Si è verificato un errore :(',
                            text: 'Purtroppo qualcosa è andato storto e non è stato possibile eliminare la vendita. Riprova più tardi.',
                            customClass: {
                                confirmButton: 'btn btn-success'
                            }
                        });
                        reject()
                    })
                });
            },
        }).then(function (result) {
            if (result.value) {
                global.SweetAlert.fire({
                    icon: 'success',
                    title: 'Vendita eliminata!',
                    text: 'Vendita eliminata correttamente.',
                    customClass: {
                        confirmButton: 'btn btn-success'
                    }
                });
                self.props.onResolve();
            }
        })
    }


    render() {
        return (
            <React.Fragment>
                <li className="list-inline-item cursor-pointer"
                    onClick={() => this.showModal()}>
                    <i className="ri-delete-bin-5-fill fs-20 text-danger"></i>
                </li>
            </React.Fragment>
        )
    }
}

export default DeleteSell;
